import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const NostraComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__nostra"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M0 11.6279L8.00736 6.83483L0 2.04179V11.6279ZM10.0004 8.02812L0 14.0145L10.0004 20L20 14.0145V2.04179L10.0004 8.02812ZM9.87395 0L5.28792 2.82116L10.0004 5.64233L14.7121 2.82116L9.87395 0Z"
        fill={colorVar}
      />
    </svg>
  );
};

export const Nostra = withIcon(NostraComponent);
